import React, { useEffect } from 'react'
import { Paper } from '@material-ui/core'
import ActionBar from 'components/ActionBar'

import { useHistory, useLocation } from 'react-router-dom'
import ViewHeader from 'components/ViewHeader'
import { useDispatch, useSelector } from 'react-redux'
import ResourceNotFound from '../../../components/ResourceNotFound'
import Loading from '../../../components/Loading'
import { EditOutlined as EditIcon, DeleteOutlineOutlined as DeleteIcon } from '@material-ui/icons'
import { useConfirm } from 'material-ui-confirm'
import BasicTable from 'components/BasicTable'
import getTableOptions from '../../../utils/getTableOptions'
import iconSlice, { fetchIcons, deleteIconById, checkCardExistsInEvents } from '../../../store/icon'
import Tooltip from '@material-ui/core/Tooltip'

import { toast } from 'utils/notify'
import { renderColInCenter, renderCol } from 'utils/renderColumns'
import { Box } from '@mui/material'

const EventCardListing = () => {
  const dispatch = useDispatch()
  const confirm = useConfirm()
  const history = useHistory()
  const location = useLocation()
  const { user } = useSelector((state) => state.auth)
  const { icons, currentPage, pageSize, inProgress } = useSelector((state) => state.icon)

  useEffect(() => {
    dispatch(fetchIcons())
  }, [dispatch])

  const tableHead = [
    {
      name: 'Color Name'
    },
    {
      name: 'Background Color',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => renderColInCenter(value),
        customHeadLabelRender: (meta) => renderColInCenter(meta.label)
      }
    },
    {
      name: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => renderCol(value),
        customHeadLabelRender: (meta) => renderCol(meta.label)
      }
    }
  ]
  const formatTableData = (icons) =>
    icons.map((icon) => [
      icon.type,
      <Box
        component="span"
        sx={{
          height: 24,
          width: 24,
          background: icon.bgColor,
          borderRadius: '8px',
          boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px'
        }}
      />,
      <>
        <Tooltip title="Edit">
          <EditIcon
            color="action"
            style={{ cursor: 'pointer' }}
            onClick={() => history.push(`${location.pathname}/edit/${icon.id}`)}
          />
        </Tooltip>
        <Tooltip title="Delete">
          <DeleteIcon
            color="action"
            style={{ marginLeft: 5, cursor: 'pointer' }}
            onClick={async () => {
              try {
                await confirm({
                  title: 'Delete Card Color',
                  description: 'Are you sure you want to delete this Card Color ?'
                })
                const isCardExistInEvents = await dispatch(checkCardExistsInEvents(icon.id))

                if (isCardExistInEvents) {
                  toast(
                    `Can not delete this Card Color because it is referenced in other Event(s).In order to delete this first remove it from all Events.`,
                    {
                      type: 'error',
                      autoClose: 5500
                    }
                  )
                } else {
                  await dispatch(deleteIconById(user?.conferenceId, icon.id))
                }
              } catch {
                // do nothing
              }
            }}
          />
        </Tooltip>
      </>
    ])

  const options = getTableOptions()

  return (
    <div>
      <ViewHeader title="Card Color">
        {inProgress && <Loading />}
        <ActionBar
          actionText="New Card Color"
          onAction={() => history.push(`${location.pathname}/new`)}
          searchPlaceholder="Search Icon"
        />
      </ViewHeader>

      {icons && icons?.length ? (
        <Paper variant="outlined" style={{ marginTop: 20 }}>
          <BasicTable
            data={formatTableData(icons)}
            columns={tableHead}
            options={{
              ...options,
              onChangePage: (page) => dispatch(iconSlice.actions.setCurrentPage(page)),
              onChangeRowsPerPage: (size) => dispatch(iconSlice.actions.setPageSize(size)),
              page: currentPage,
              rowsPerPage: pageSize
            }}
          />
        </Paper>
      ) : (
        !inProgress && <ResourceNotFound message="No card color available" />
      )}
    </div>
  )
}

export default EventCardListing
